import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';

const toPickerValue = (val) => {
  if (!val) return null;
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? null : d;
};

export default function JalaliDatePicker({
  value,
  onChange,
  label,
  placeholder,
  endOfDay = false,
  sx,
  ...props
}) {
  const pickerValue = useMemo(() => toPickerValue(value), [value]);

  const handleChange = (newValue) => {
    if (!newValue) {
      onChange('');
      return;
    }
    const base = dayjs(newValue);
    const finalized = endOfDay
      ? base.endOf('day')
      : base.startOf('day');
    onChange(finalized.toISOString());
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <DatePicker
        label={label}
        value={pickerValue}
        onChange={handleChange}
        format="yyyy/MM/dd"
        slotProps={{
          textField: {
            placeholder,
            size: 'small',
            fullWidth: true,
            inputProps: { dir: 'ltr' },
          },
        }}
        sx={sx}
        {...props}
      />
    </LocalizationProvider>
  );
}
